import { Alert, Button } from "@mui/material";
import FormDatePicker from "components/FormFields/FormDatePicker";

import FormTextField from "components/FormFields/FormTextField";
import ModalContainer from "components/common/modals/modalContainer/ModalContainer";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { DATE_FORMAT } from "static/date";
import { validateEmail } from "utils/common";
import { getFormattedDate, isValidDateFormat } from "utils/date";

const NoShowEmailModal = ({
  isModalOpen,
  onClose,
  onSubmit,
  patientEmail,
  isDateRequired,
}) => {
  const [email, setEmail] = useState();
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isEmailUpdated, setIsEmailUpdated] = useState(false);
  const [date, setDate] = useState("");
  const [isDateValid, setIsDateValid] = useState(false);

  useEffect(() => {
    setEmail(patientEmail);
  }, [patientEmail]);

  useEffect(() => {
    const hasValidDate = date && isValidDateFormat(date, DATE_FORMAT.DEFAULT);
    setIsDateValid(hasValidDate);
  }, [date]);

  const orderedDatelabel = "Ordered Date";

  return (
    <ModalContainer
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title={`Enter Email${isDateRequired ? ", " + orderedDatelabel : ""}`}
    >
      <div className="mt-2 generate-template-modal__content">
        <p>
          <span>
            Verify the patient's email address to send the no show email to.
            Please update the email address if required.
          </span>
        </p>
      </div>

      <FormTextField
        label="Email"
        value={email}
        type={email}
        required
        fullWidth={true}
        onChange={(event) => {
          const updatedEmail = event.target.value;
          setEmail(updatedEmail);
          setIsSubmitClicked(false);
          setIsEmailUpdated(updatedEmail !== patientEmail);
        }}
        errorMessage={
          !isEmailValid
            ? "Invalid patient email."
            : "Patient email is required."
        }
        hasError={isSubmitClicked && (!email || !isEmailValid)}
      />

      {isDateRequired && (
        <FormDatePicker
          label={orderedDatelabel}
          required={isDateRequired}
          format={DATE_FORMAT.DEFAULT}
          value={date ? dayjs(date) : null}
          onChange={(value) => {
            const formattedDate = getFormattedDate(value, DATE_FORMAT.DEFAULT);
            setDate(formattedDate);
          }}
          errorMessage={
            isSubmitClicked && !date ? "Date is required." : "Invalid date."
          }
          maxDate={dayjs(new Date())}
          hasError={isSubmitClicked && (!date || !isDateValid)}
        />
      )}

      {isEmailUpdated && (
        <Alert severity="warning" className="mt-3 mb-3">
          The patient's email as above will be updated once the email is sent.
        </Alert>
      )}

      <div className="mt-2 generate-template-modal__footer">
        <Button variant="outlined" color="secondary" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          variant="contained"
          style={{
            backgroundColor: "#94ba33",
            color: "white",
          }}
          onClick={() => {
            const isEmailValid = validateEmail(email);
            setIsEmailValid(isEmailValid);
            setIsSubmitClicked(true);

            const isValidated = isDateRequired
              ? isDateValid && isEmailValid
              : isEmailValid;

            isValidated && onSubmit(email, date);
          }}
        >
          Send Email
        </Button>
      </div>
    </ModalContainer>
  );
};

export default NoShowEmailModal;
